export default __webpack_public_path__ + "static/media/gallery-wip-emitter_12.efce3c70.jpg";